import React from "react";
import "./About.css";
import "../Products/Products.css"
const About = () => {
  return (
    <div className="aboutUsContainer">
      <div className="aboutUs-intro-img">
        <img
          src="https://dg1xqmhtoint1.cloudfront.net/img/pgdm/blog/businessman-hand-holding-creative-light-bulb-with-marketing-network-icons-planning-strategy-pdgm.webp?mtime=20220506115838&focal=none"
          alt="background"
          className="aboutUs-image"
        />
        <div className="aboutUs-introText">
          <div className="aboutUs-welove">
            WE <span>❤️</span> WHAT WE DO!
          </div>
          <p className="aboutUs-description">
            Our passion drives us to create exceptional software solutions. We
            believe in delivering stunning, user-friendly designs.
          </p>
        </div>
      </div>

      <div className="vision">
        <h1>Our Vision and Mission</h1>
        <p>At WorkMomentum Solutions, our mission is to provide a full spectrum of technology
            solutions that include web development, mobile apps, cloud, and DevOps services,
            all with a focus on one-click deployment. We aim to empower our customers with seamless,
            efficient, and scalable solutions that meet their unique needs.
          </p>
      </div>

      <div className="unique">
        <h1>Why are we unique?</h1>
        <p>
          We have a unique vision and values guiding us in a specific direction.
          Our experience and commitment to operational excellence guarantee
          successful deliveries. But we go beyond creating exceptional solutions
          – we aim to be your trusted business partner.
        </p>
        <div className="products-offer">
          <div className="products-offer-card">
            <div className="icon-circle">
              <i className="fas fa-code"></i>
            </div>
            <h2>Technical skills</h2>
            <p style={{fontSize:'20px'}}>
              The clients greatly appreciate the technical expertise of
              WorkMomentum's specialists in both web and mobile development. Our
              pros stay up-to-date with trends and best practices to craft
              innovative, reliable, and secure systems.
            </p>
          </div>
          <div className="products-offer-card">
            <div className="icon-circle">
              <i className="fas fa-briefcase"></i>
            </div>
            <h2>Professionalism</h2>
            <p style={{fontSize:'20px'}}>
              You can count on us for timely delivery and the superior quality
              of provided services. To maximize our clients’ potential, we focus
              on producing business value every single day.
            </p>
          </div>
          <div className="products-offer-card">
            <div className="icon-circle">
              <i className="fas fa-tasks"></i>
            </div>
            <h2>Clear frameworks and procedures</h2>
            <p style={{fontSize:'20px'}}>
              Our well-defined workflows enable us to deliver first-class
              software consistently. The agile approach we use in product
              development ensures productivity and on-time deployment.
            </p>
          </div>
          <div className="products-offer-card">
            <div className="icon-circle">
              <i className="fas fa-handshake"></i>
            </div>
            <h2>Seamless sales process</h2>
            <p style={{fontSize:'20px'}}>
              Experience a seamless sales journey with us. We prioritize our
              partners’ needs, promptly addressing any inquiries and offering
              comprehensive guidance at every step. We don’t merely provide
              services, we stand as your committed business ally.
            </p>
          </div>
          <div className="products-offer-card">
            <div className="icon-circle">
              <i className="fas fa-industry"></i>
            </div>
            <h2>Experience with SMCs and enterprises</h2>
            <p style={{fontSize:'20px'}}>
              Numerous collaborations with SMCs and large businesses are a
              testament to our capabilities. Whether you’re a growing company
              seeking scalable solutions or an established corporation with
              complex requirements, we’ve got you covered.
            </p>
          </div>
          <div className="products-offer-card">
            <div className="icon-circle">
              <i className="fas fa-chart-line"></i>
            </div>
            <h2>Industry level Expertise</h2>
            <p style={{fontSize:'20px'}}>
            Industry-level expertise refers to a deep and comprehensive understanding 
            of a specific industry, encompassing its trends, challenges, regulations, 
            and best practices. It involves the ability to leverage this knowledge to make 
            informed decisions, drive innovation, and maintain a competitive edge.
            </p>
          </div>
        </div>
      </div>
      {/* <div className="about-members">
        <h1 className="aboutus-heading">About Us</h1>
        <div className="member">
          <div className="member-image">
            <img src="abhilash1.png" alt="Abhilash" />
            <div>
              <h1>Abhilash</h1>
              <h3>CEO & Co-Founder</h3>
            </div>
          </div>
          <div className="member-text">
            <p>
              Abhilash is the driving force behind WorkMomentum, a company
              dedicated to delivering comprehensive and innovative technology
              solutions. With a solid foundation in product development, cloud
              computing, and DevOps, Abhilash has consistently pushed the
              envelope to create cutting-edge solutions that simplify and
              enhance the digital experiences of businesses worldwide.
            </p>
            <p>
              From the beginning, my goal has been to build a company that
              offers end-to-end technology solutions under one roof. Whether
              it's a sophisticated mobile app, a robust cloud infrastructure, or
              seamless DevOps integration, WorkMomentum Solutions is committed
              to delivering excellence. I am immensely proud of what we have
              achieved so far and excited about the innovations we have in the
              pipeline. Thank you for being a part of our journey.
            </p>
            <p>
              Abhilash holds a degree from IIIT. With extensive experience in
              developing products and solutions across various domains, he has a
              proven track record of turning complex problems into simple,
              elegant solutions.
            </p>
          </div>
        </div>
        <div className="member">
          <div className="member-text">
            <p>
              Venkatesh is a key pillar of WorkMomentum, bringing his vast
              expertise in full-stack web application development to the team.
              With a Master's degree in Information Systems from Saint Louis
              University, Missouri, USA, Venkatesh combines deep technical
              knowledge with a passion for creating robust and scalable web
              solutions.
            </p>
            <p>
              Joining WorkMomentum has been a thrilling journey. My focus has
              always been on leveraging the latest technologies to build web
              applications that are not only functional but also scalable and
              user-friendly. I'm proud of our team's dedication and look forward
              to continuing our mission to provide top-notch solutions to our
              clients.
            </p>
            <p>
              With years of experience in developing full-stack web
              applications, Venkatesh has been instrumental in building the
              frameworks and platforms that power WorkMomentum diverse range of
              services. His technical acumen and strategic vision have helped
              the company achieve new heights.
            </p>
          </div>
          <div className="member-image">
            <img src="venkatesh.png" alt="Venkatesh" />
            <div>
              <h1>Venkatesh</h1>
              <h3>CTO & Co-Founder</h3>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default About;

// const About = () => {
//   return (
//     <div className='about'>
//       <h1 className='about-header'>Building Tomorrow's Solutions Today</h1>
//       <div className='vision'>
//         <div className='mission'>
//           <h1>Our Vision and Mission</h1>
          // <p>At WorkMomentum Solutions, our mission is to provide a full spectrum of technology
          //   solutions that include web development, mobile apps, cloud, and DevOps services,
          //   all with a focus on one-click deployment. We aim to empower our customers with seamless,
          //   efficient, and scalable solutions that meet their unique needs.
          // </p>
//         </div>
//         <div className='mission-image'>
//           <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTCYH0y8v3R3xomRSuH-BHH125yGfT0SoMpSa4uASuYwWbDIjcMf4VIZAjxZlB9HR7WCYU&usqp=CAU" alt=""/>
//         </div>
//       </div>
//       <div className='unique'>
//         <h1>Why are we unique?</h1>
//         <p>We have a unique vision and values guiding us in a specific direction. Our experience and commitment to operational excellence guarantee successful deliveries. But we go beyond creating exceptional solutions – we aim to be your trusted business partner.</p>
//         <div className='products-offer'>
//           <div className='products-offer-card'>
//             <h2>Technical skills</h2>
//             <p>The clients greatly appreciate the technical expertise of WorkMomentum's specialists in both web and mobile development. Our pros stay up-to-date with trends and best practices to craft innovative, reliable, and secure systems.</p>
//           </div>
//           <div className='products-offer-card'>
//             <h2>Professionalism</h2>
//             <p>You can count on us for timely delivery and the superior quality of provided services. To maximize our clients’ potential, we focus on producing business value every single day.</p>
//           </div>
//           <div className='products-offer-card'>
//             <h2>Clear frameworks and procedures</h2>
//             <p>Our well-defined workflows enable us to deliver first-class software consistently. The agile approach we use in product development ensures productivity and on-time deployment.</p>
//           </div>
//           <div className='products-offer-card'>
//             <h2>Seamless sales process</h2>
//             <p>Experience a seamless sales journey with us. We prioritize our partners’ needs, promptly addressing any inquiries and offering comprehensive guidance at every step. We don’t merely provide services, we stand as your committed business ally.</p>
//           </div>
//           <div className='products-offer-card'>
//             <h2>Experience with SMCs and enterprises</h2>
//             <p>Numerous collaborations with SMCs and large businesses are a testament to our capabilities. Whether you’re a growing company seeking scalable solutions or an established corporation with complex requirements, we’ve got you covered.</p>
//           </div>
//           <div className='products-offer-card'>
//             <h2>Industry level Exertise</h2>
//             <p>Numerous collaborations with SMCs and large businesses are a testament to our capabilities. Whether you’re a growing company seeking scalable solutions or an established corporation with complex requirements, we’ve got you covered.</p>
//           </div>
//         </div>
//       </div>

//       <div className='about-members'>
//       <h2 className='aboutus-heading'>About Us</h2>
//         <div className='member'>
//           <div className='member-image'>
//             <img src="abhilash1.png" alt="Abhilash" />
//             <div>
//               <h1>Abhilash</h1>
//               <h3>CEO & Co-Founder</h3>
//             </div>
//           </div>
//           <div className='member-text'>
//             <p>Abhilash is the driving force behind WorkMomentum, a company dedicated to delivering comprehensive and innovative technology solutions. With a solid foundation in product development, cloud computing, and DevOps, Abhilash has consistently pushed the envelope to create cutting-edge solutions that simplify and enhance the digital experiences of businesses worldwide.</p>
//             <p>From the beginning, my goal has been to build a company that offers end-to-end technology solutions under one roof. Whether it's a sophisticated mobile app, a robust cloud infrastructure, or seamless DevOps integration, WorkMomentum Solutions is committed to delivering excellence. I am immensely proud of what we have achieved so far and excited about the innovations we have in the pipeline. Thank you for being a part of our journey.</p>
//             <p>Abhilash holds a degree from IIIT. With extensive experience in developing products and solutions across various domains, he has a proven track record of turning complex problems into simple, elegant solutions.</p>
//           </div>
//         </div>
//         <div className='member'>
//           <div className='member-text'>
//             <p>Venkatesh is a key pillar of WorkMomentum, bringing his vast expertise in full-stack web application development to the team. With a Master's degree in Information Systems from Saint Louis University, Missouri, USA, Venkatesh combines deep technical knowledge with a passion for creating robust and scalable web solutions.</p>
//             <p>Joining WorkMomentum has been a thrilling journey. My focus has always been on leveraging the latest technologies to build web applications that are not only functional but also scalable and user-friendly. I'm proud of our team's dedication and look forward to continuing our mission to provide top-notch solutions to our clients.</p>
//             <p>With years of experience in developing full-stack web applications, Venkatesh has been instrumental in building the frameworks and platforms that power WorkMomentum diverse range of services. His technical acumen and strategic vision have helped the company achieve new heights.</p>
//           </div>
//           <div className='member-image'>
//             <img src="venkatesh.png" alt="Venkatesh" />
//             <div>
//               <h1>Venkatesh</h1>
//               <h3>CTO & Co-Founder</h3>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default About;
